// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/form/history/history.scss
// module id = 1919
// module chunks = 50